import React, { useEffect, useMemo } from 'react';
import s from './styles.module.scss';
import { IAyat } from '@/infrastructure/interfaces/i-ayat';
import { useRouter } from 'next/router';
import { Ayat } from '@/infrastructure/class/ayat';
import { sortArrayByFieldName } from '@/utils/helpers/sort-array-by-field-name';
import AyasListItem, { ayatId } from './item';
import { scrollToElement } from '@/utils/helpers/scroll-to-element';
import { AudioSurah } from '@/infrastructure/class/audio-surah';
import { ReadSurah } from '@/infrastructure/class/read-surah';
import { isArabic } from '@/utils/helpers/is-arabic';

interface IAyasListProps {
  items: IAyat[];
  surah: AudioSurah | ReadSurah;
  className?: string;
  onAyatView?: (ayat: Ayat) => void;
}

const AyasList: React.FC<IAyasListProps> = (props) => {
  const { items, surah, onAyatView = () => {} } = props;

  const router = useRouter();
  const { locale, query } = router;
  const { number } = query;

  const isArabicTranslation = useMemo(() => {
    let text = '';
    if (items?.length > 0) {
      const ayat = items[0];
      text = ayat?.translate || '';
    }

    return isArabic(text);
  }, [items]);

  const ayas = useMemo<Ayat[]>(
    () =>
      sortArrayByFieldName(
        items.map((reciter) => new Ayat(reciter, locale)),
        'number'
      ),
    [items, locale]
  );

  useEffect(() => {
    if (number) {
      const ayat = document.getElementById(ayatId(Number(number)));
      if (ayat) {
        scrollToElement(ayat, 500);
      }
    }
  }, [number]);

  return (
    <ul className={s['list']}>
      {ayas.map((ayat) => (
        <AyasListItem
          key={ayat.number}
          data={ayat}
          surah={surah}
          isArabicTranslation={isArabicTranslation}
          onView={onAyatView}
        />
      ))}
    </ul>
  );
};

export default AyasList;
